'use strict';

import controller from './confirmar.controller';
import template from './confirmar.html';

const ConfirmarCuentaComponent = {
    bindings: {},
    controller,
    template
};

export default ConfirmarCuentaComponent;


// WEBPACK FOOTER //
// ./src/app/components/admin/centralizador/confirmar/confirmar.component.js